// extracted by mini-css-extract-plugin
export var button = "styles-module--button--eeebf";
export var disabled = "styles-module--disabled--323ef";
export var link = "styles-module--link--2b7cf";
export var outlined = "styles-module--outlined--95f70";
export var primary = "styles-module--primary--b1592";
export var withIcon = "styles-module--withIcon--c4213";